module.exports = __webpack_public_path__ + "static/media/eventxtra-logo-white.8928095d.svg";